import React, { Component } from 'react';
import { translate } from 'react-i18next';

class PromoCodeContainer extends Component {

    render = () => {
        return (
            <div className="page-info-container">
                <div className="page-info-title">
                    <h2>
                        ZANQ the venue by Cinco catering
                    </h2>
                </div>
                <div className="page-info-container">
                    <div className="page-info-adress">
                        <p style={{color: "#FCFDFD"}}>
                            David Alfaro Siqueiros 104,
                            Zona Valle Oriente, 66269 San Pedro Garza García, N.L.
                        </p>
                    </div>
                    <div className="page-info-date">
                        <p  style={{color: "#FCFDFD"}}>
                            19 de Octubre del 2023
                        </p>
                    </div>
                    <div className="page-info-promocode">
                        <div className="col-xs-12">
                            <div className="form-group flex">
                                <input
                                    className="form-control"
                                    maxLength="16"
                                    onChange={this.props.handleChangePromocode}
                                    type="text"
                                    value={this.props.promoCode} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-info-buttom">
                    <div className="page-info-pay">
                        <table>
                            <tbody>
                                <tr>
                                    <td>Subtotal:</td>
                                    <td style={{ textAlign: "right" }}>1990 MXN</td>
                                </tr>
                                {this.props.porcentaje_summit
                                    ? (
                                        <tr>
                                            <td>Porcentaje de Descuento:  </td>
                                            <td style={{ textAlign: "right" }}>{this.props.porcentaje_summit}%</td>
                                        </tr>
                                    )
                                    : null
                                }
                                {this.props.porcentaje_summit
                                    ? (
                                        <tr>
                                            <td>Descuento: </td>
                                            <td style={{ textAlign: "right" }}>{((this.props.porcentaje_summit / 100) * 1990).toFixed(2)}MXN</td>
                                        </tr>
                                    )
                                    : null
                                }
                                {this.props.porcentaje_summit
                                    ? (
                                        <tr>
                                            <td>Total: </td>
                                            <td style={{ textAlign: "right" }}>{((1 - (this.props.porcentaje_summit / 100)) * 1990).toFixed(2)}MXN</td>
                                        </tr>
                                    )
                                    : (
                                        <tr>
                                            <td>Total: </td>
                                            <td style={{ textAlign: "right" }}>1990 MXN</td>
                                        </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(PromoCodeContainer);


// WEBPACK FOOTER //
// ./src/guest/summit/PromoCodeContainer.js